<template>
  <div class="card-detail-request">
    <header>
      <div
        aria-label="Icono de usuario registrado correctamente"
        :class="{
          'icon-container' : true,
        }"
      >
        <i
          :class="{
            'icon-container__icon' : true,
            'pi pi-check': true,
          }"
        ></i>
      </div>
      <h1>
        Usuario registrado correctamente.
      </h1>
    </header>
    <section>
      <div class="body__code">
        <p class="body__code__label">
          Tu código de {{ detailText['main'] }} es
        </p>
        <p class="body__code__value">
          {{ state$$.detailModel?.mitmaCode }}
          <i
            v-tooltip.right="{ value: 'Copiar a portapapeles'}"
            class="body__code__value__icon pi pi-copy"
            aria-label="Copiar a portapapeles"
            role="button"
            @click="copy(state$$.detailModel?.mitmaCode)"
          ></i>
        </p>
        <div class="body__code__QR">
          <img
            v-if="state$$.detailModel?.mitmaCode"
            class="body__code__QR__img"
            :src="qrcode"
            alt="Imagen de QR código MITMA"
          />
        </div>
      </div>
      <div class="body__description">
        <p>
          Proporciona este código a la empresa
          operadora a la hora de adquirir el {{ typePortal === 'verano-joven' ? 'billete' : 'abono' }} para el descuento.
        </p>
        <p>
          Las empresas pondrán en marcha la venta de los
          {{ typePortal === 'verano-joven' ? 'billetes' : 'abonos' }} con descuentos a medida que vayan adaptando sus sistemas.
        </p>
        <p>
          Más información en <a
            :href="URL_MORE_INFO"
            :aria-label="`Enlace a la página de información de ${mainText}`"
          >
            “{{ mainText }}”
          </a>
        </p>
      </div>
      <!-- <div
        v-show="orientation === 'landscape-primary'"
        class="body__trip"
      >
        <DataTable
          v-if="showTripTable && appState$$.isLogged"
          :value="dataTrips"
          class="body__trip__table"
          paginator
          :rows="5"
          :rows-per-page-options="[5, 10, 20]"
        >
          <Column
            field="companyName"
            header="Empresa"
          ></Column>
          <Column
            field="originCity"
            header="Ciudad de origen"
            :sortable="true"
          ></Column>
          <Column
            field="destinationCity"
            header="Ciudad de destino"
            :sortable="true"
          ></Column>
          <Column
            field="departureDate"
            header="Fecha"
          >
            <template #body="{ data }">
              {{ useDateFormat(data.departureDate, 'DD-MM-YYYY HH:mm:ss').value }}
            </template>
          </Column>
          <Column
            field="mode"
            header="Modo de transporte"
            header-style="display: flex; justify-content: center; align-items: center;"
            class="text-center body__trip__table__cell-icon"
          >
            <template #body="{ data }">
              <img
                v-if="!isLoadingTraing && data.mode === 'train'"
                :src="iconTrain"
                alt="Icono de modo de transporte tren"
                class="body__trip__table__cell-icon__img"
              />

              <img
                v-if="!isLoadingBus && data.mode === 'bus'"
                :src="iconBus"
                alt="Icono de modo de transporte autobús"
                class="body__trip__table__cell-icon__img"
              />
            </template>
          </Column>

          <template #empty>
            Actualmente no tiene viajes registrados.
          </template>
        </DataTable>
      </div> -->
    </section>
    <footer>
      <div class="footer">
        <p class="footer__date">
          <span>Fecha de registro:</span>
          <span>
            <strong>
              {{ transformTimestampStringNotDateWhithOutHour(state$$.detailModel?.registeredDate) }}
            </strong>
          </span>
        </p>
        <DetailRequestKeypad />
      </div>
    </footer>
  </div>
</template>

<script setup>
// #region VUE
import {
  inject,
  onMounted,
  computed,
  ref,
} from 'vue';
import {useStore} from 'vuex';

// import {useImage} from '@vueuse/core';
// #endregion

// import {
//   // useNormalizer,
//   useDev,
// } from '@sttedra_ui/framework';

// #region COMPONENTS COMPOSABLES
import DetailRequestKeypad from '../DetailRequestKeypad.vue';

// import {
// useDateFormat,
// useScreenOrientation,
// } from '@vueuse/core';

// import DataTable from 'primevue/datatable';
// import Column from 'primevue/column';

import {useClipboard} from '@vueuse/core';
import {useQRCode} from '@vueuse/integrations/useQRCode';

import useTransformToTimestampString from '@/composables/transform-timestamp-string';
// #endregion

// #region API
// import {StatusCodes as HttpStatus} from 'http-status-codes';
// import {getTrips as getTripspApi} from '@/api/trips/trips.api';
// #endregion

// #region Props, Emits
// ...
// #endregion

// #region Params, Ref, Reactives, Computed
const state$$ = inject('detailRequestState$$');
const store = useStore();
const mainText = computed(() => store.getters['text/getSectionTexts']('main'));
const detailText = computed(() => store.getters['text/getSectionTexts']('detail-request'));
const {copy} = useClipboard();
const {transformTimestampStringNotDateWhithOutHour} = useTransformToTimestampString();
// const {orientation} = useScreenOrientation();

const URL_MORE_INFO = STTEDRA_URL_MORE_INFORMATION;

const typePortal = ref(STTEDRA_TYPE_PORTAL);
const qrcode = useQRCode(state$$.detailModel?.mitmaCode || '');

// const showTripTable = ref(false);
// const dataTrips = ref([]);

// const iconTrain = require('@/assets/images/train.png');
// const iconBus = require('@/assets/images/bus.png');

// const {isLoading: isLoadingTraing} = useImage({src: iconTrain});
// const {isLoading: isLoadingBus} = useImage({src: iconBus});
// #endregion

// #region Functions
// ...
// #endregion

// #region Effects, Hooks
// ...
// #endregion

// #region Provide, Expose
onMounted(async () => {
  // const {
  //   dataModel,
  //   response,
  // } = await getTripspApi();

  // if (response?.status !== HttpStatus.OK && response?.status !== HttpStatus.NO_CONTENT) {
  //   useDev.error('[DetailRequestApproved] getTripspApi', response);
  //   dataTrips.value = [];
  //   showTripTable.value = false;
  // }

  // useDev.log('[DetailRequestApproved] orientation', orientation);

  // dataTrips.value = dataModel;
  // showTripTable.value = true;
  // useDev.log('[DetailRequestApproved] trips', dataTrips.value);
});
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;
.card-detail-request{
  align-items: center;
  display: flex;
  flex-direction: column;

  gap: $brand__boxspace--medium;
  padding: $brand__boxspace--medium * 2;

  header, section, footer{
    align-items: center;
    display: flex;
    flex-direction: column;

    text-align: center;

    gap: $brand__boxspace--medium;
  }

  header{
    gap: $brand__boxspace--medium * 2;
    .icon-container{
      background-color: $pv__color--green-alter;
      border-radius: $pv__br--circle;
      color: $pv__color--white;
      flex: 1;
      padding: $brand__boxspace--medium;
      width: fit-content;
      &__icon{
        @include media("<=phone") {
          font-size: $pv__dm__icon--largue;
        }
        @include media(">phone") {
          font-size: $pv__dm__icon--largue;
        }
      }
    }
  }

  section{
    .body__code{
      align-items: center;
      display: flex;
      flex-direction: column;
      &__label{
        font-size: $pv__fs--large;
        margin-bottom: $brand__boxspace--small;
      }
      &__value{
        align-items: center;
        display: flex;
        font-size: $pv__fs--xxlarge;
        font-weight: bold;
        gap: $brand__boxspace--small;
        margin-top: $brand__boxspace--small;
        &__icon{
          border-radius: $pv__br--circle;
          color: $pv__color--black;
          cursor:pointer;
          @include media("<=phone") {
            font-size: $pv__dm__icon--largue;
          }
          @include media(">phone") {
            font-size: $pv__dm__icon--largue;
          }
          &:hover{
            color: $pv__color--green;
          }
        }
      }
      &__QR{
        &__img {
          min-width: 200px;
        }
      }
    }
    .body__description{
      align-items: center;
      display: flex;
      flex-direction: column;
      & p {
        font-size: $pv__fs--large;
        & a{
          color: $pv__color--green-alter;
          text-decoration: underline;
        }
      }
    }
    .body__trip{
      display: flex;
      width: 100%;
      &__table{
        flex: 1;
        &__cell-icon{
          &__img{
            height: 50px;
            @include media("<=phone") {
              height: 30px;
            }
          }
        }
      }
    }
  }

  footer{
    .footer{
      &__date {
        align-items: center;
        display: flex;
        font-size: $pv__fs--large;
        gap: $brand__boxspace--small;
        justify-content: center;
        @include media("<=phone") {
          flex-direction: column;
        }
        @include media(">phone") {
          flex-direction: row;
        }
      }
    }
  }
}
</style>
